import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, HostBinding, EventEmitter, ElementRef, Component, Inject, Input, Output, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinBlurEvent, mixinFocusEvent, mixinChangeEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/switch/switch';

class FadvSwitchOnDirective {
    constructor() {
        this.slotName = 'checked';
    }
}
FadvSwitchOnDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchOnDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvSwitchOnDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvSwitchOnDirective, selector: "[fadvSwitchOnIcon]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchOnDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fadvSwitchOnIcon]',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvSwitchOffIconDirective {
    constructor() {
        this.slotName = 'unchecked';
    }
}
FadvSwitchOffIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchOffIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvSwitchOffIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvSwitchOffIconDirective, selector: "[fadvSwitchOffIcon]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchOffIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fadvSwitchOffIcon]',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvSwitchComponent extends mixinBlurEvent(mixinFocusEvent(mixinChangeEvent(mixinFormControl(FadvBaseComponent)))) {
    constructor(el) {
        super(el);
        /* Draws the switch in a checked state. */
        this.checked = false;
        /* When the control is in an invalid state, this will be true and is determined by the required prop. */
        this.invalid = false;
        /* Makes the switch a required field. */
        this.required = false;
        this.checkedChange = new EventEmitter();
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((checked) => (this.checked = checked));
        this.registerSubscription(this.changed, () => {
            var _a, _b;
            // checkboxes work a little different for template forms and reactive forms.
            // In a template form the binding is more then likely on the check property
            const checked = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.checked;
            this.checkedChange.emit(checked);
            // On a reactive form, if a value is set, then it's more likely that the value is
            // wanted in the form. If there is no value report the check change
            if (this.value) {
                this.reportChange(checked ? this.value : null);
            }
            else {
                this.reportChange(checked);
            }
        });
        this.registerSubscription(this.blurred, () => this.onTouched());
    }
}
FadvSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvSwitchComponent, selector: "fadv-switch", inputs: { value: "value", disabled: "disabled", checked: "checked", invalid: "invalid", name: "name", required: "required", checkedLabel: "checkedLabel", uncheckedLabel: "uncheckedLabel", size: "size" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred", changed: "changed", checkedChange: "checkedChange" }, providers: [createFormControlProvider(FadvSwitchComponent)], usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvSwitchComponent.prototype, "checked", void 0);
__decorate([
    Forward()
], FadvSwitchComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvSwitchComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvSwitchComponent.prototype, "required", void 0);
__decorate([
    Forward()
], FadvSwitchComponent.prototype, "checkedLabel", void 0);
__decorate([
    Forward()
], FadvSwitchComponent.prototype, "uncheckedLabel", void 0);
__decorate([
    Forward()
], FadvSwitchComponent.prototype, "size", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-switch',
                    template: '<ng-content></ng-content>',
                    providers: [createFormControlProvider(FadvSwitchComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { checked: [{
                type: Input
            }], invalid: [{
                type: Input
            }], name: [{
                type: Input
            }], required: [{
                type: Input
            }], checkedLabel: [{
                type: Input
            }], uncheckedLabel: [{
                type: Input
            }], size: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }] } });

class FadvSwitchModule {
}
FadvSwitchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvSwitchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchModule, declarations: [FadvSwitchComponent, FadvSwitchOnDirective, FadvSwitchOffIconDirective], imports: [FadvCommonModule], exports: [FadvSwitchComponent, FadvSwitchOnDirective, FadvSwitchOffIconDirective] });
FadvSwitchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvSwitchComponent, FadvSwitchOnDirective, FadvSwitchOffIconDirective],
                    imports: [FadvCommonModule],
                    exports: [FadvSwitchComponent, FadvSwitchOnDirective, FadvSwitchOffIconDirective],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvSwitchComponent, FadvSwitchModule, FadvSwitchOffIconDirective, FadvSwitchOnDirective };
